._notice_1f74v_1 {
  max-width: px(350);
  margin-left: auto;
  margin-right: auto;
  top: 45%;
}